module.exports = global["$"] = require("-!/Users/kpowers/Workspaces/availity-uikit/packages/docs/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 126
// module chunks = 114276838955818